import { useEffect, useState } from 'react';

import { Col, Radio, Row, Select, Switch } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';

import * as S from './styled';

import { getProfileList } from '../../../hooks/dynamicPricing';

export type DynamicPricingFormProps = {
  loading?: boolean;
  editValues?: any;
};

const DynamicPricingForm = ({
  loading,
  editValues,
}: DynamicPricingFormProps) => {
  const { setFieldValue, values, setFieldError } = useFormikContext<any>();

  const [profiles, setProfiles] = useState();
  const [profileType, setProfileType] = useState('station');

  useEffect(() => {
    (async () => {
      const { dynamicPricingList } = await getProfileList();

      if (dynamicPricingList.length) {
        setProfiles(
          dynamicPricingList.map((profile) => ({
            label: profile.name,
            value: profile.uuid,
          })),
        );
      }
    })();
  }, []);

  useEffect(() => {
    if (editValues?.enabled) {
      setFieldValue('dynamic_pricing.enabled', editValues.enabled);

      if (
        editValues?.connector1_dynamic_pricing_id ===
          editValues?.connector2_dynamic_pricing_id &&
        editValues?.connector2_dynamic_pricing_id ===
          editValues?.connector3_dynamic_pricing_id
      ) {
        setProfileType('station');
      } else {
        setProfileType('connectors');
      }

      setFieldValue(
        'dynamic_pricing.connector1_dynamic_pricing_id',
        editValues?.connector1_dynamic_pricing_id,
      );
      setFieldValue(
        'dynamic_pricing.connector2_dynamic_pricing_id',
        editValues?.connector2_dynamic_pricing_id,
      );
      setFieldValue(
        'dynamic_pricing.connector3_dynamic_pricing_id',
        editValues?.connector3_dynamic_pricing_id,
      );
    }
  }, [editValues, setFieldValue]);

  return (
    <Row gutter={24} style={{ marginTop: 8 }}>
      <Col md={24}>
        <div
          style={{
            display: 'flex',
            borderRadius: 3,
            borderColor: 'rgba(0, 0, 0, 0.20)',
            borderWidth: 1,
            borderStyle: 'solid',
            padding: 24,
            paddingLeft: 12,
          }}
        >
          <Col
            lg={values.dynamic_pricing?.enabled ? 8 : 24}
            style={{ display: 'flex' }}
          >
            <S.SwitchWrapper>
              <Switch
                checked={values.dynamic_pricing?.enabled}
                disabled={loading}
                onChange={(value) => {
                  setFieldValue('dynamic_pricing.enabled', value);

                  setProfileType('station');

                  setFieldValue('dynamic_pricing.type', 'station');
                }}
              />
            </S.SwitchWrapper>
            <S.Label style={{ marginLeft: 16 }}>Recarga será cobrada</S.Label>
          </Col>

          {values.dynamic_pricing?.enabled && (
            <Col lg={16} style={{ padding: 0 }}>
              <Row>
                <Col lg={10}>
                  <S.Label>Definir cobrança por:</S.Label>

                  <Radio.Group
                    defaultValue={profileType}
                    style={{ marginTop: 16 }}
                    onChange={({ target }) => {
                      setProfileType(target.value);
                      setFieldValue('dynamic_pricing.type', target.value);

                      setFieldValue(
                        'dynamic_pricing.connector1_dynamic_pricing_id',
                        '',
                      );
                      setFieldValue(
                        'dynamic_pricing.connector2_dynamic_pricing_id',
                        '',
                      );
                      setFieldValue(
                        'dynamic_pricing.connector3_dynamic_pricing_id',
                        '',
                      );

                      setFieldError(
                        'dynamic_pricing.connector1_dynamic_pricing_id',
                        '',
                      );
                      setFieldError(
                        'dynamic_pricing.connector2_dynamic_pricing_id',
                        '',
                      );
                      setFieldError(
                        'dynamic_pricing.connector3_dynamic_pricing_id',
                        '',
                      );
                    }}
                  >
                    <Radio value='station' style={{ fontWeight: 300 }}>
                      Por estação
                    </Radio>
                    <Radio value='connectors' style={{ fontWeight: 300 }}>
                      Por conectores
                    </Radio>
                  </Radio.Group>
                </Col>

                {profileType === 'station' && (
                  <Col lg={14}>
                    <S.Label>
                      Selecione o perfil de precificação para o grupo
                    </S.Label>

                    <Select
                      placeholder='Escolha o perfil de precificação'
                      style={{ marginTop: 8, width: '100%', fontWeight: 300 }}
                      size='large'
                      options={profiles}
                      onChange={(value) => {
                        setFieldValue(
                          'dynamic_pricing.connector1_dynamic_pricing_id',
                          value,
                        );
                        setFieldValue(
                          'dynamic_pricing.connector2_dynamic_pricing_id',
                          value,
                        );
                        setFieldValue(
                          'dynamic_pricing.connector3_dynamic_pricing_id',
                          value,
                        );
                      }}
                      value={
                        profiles
                          ? values.dynamic_pricing.connector2_dynamic_pricing_id
                          : undefined
                      }
                    />

                    <ErrorMessage
                      name='dynamic_pricing.connector1_dynamic_pricing_id'
                      component={S.MessageBox}
                    />
                  </Col>
                )}
              </Row>

              {profileType === 'connectors' && (
                <Row gutter={24} style={{ marginTop: 24 }}>
                  <Col lg={24}>
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                      <Col lg={9}>
                        <S.ConnectorWrapper>Conector #1</S.ConnectorWrapper>
                      </Col>
                      <Col lg={15}>
                        <Select
                          placeholder='Escolha o perfil de precificação'
                          style={{ width: '100%', fontWeight: 300 }}
                          size='large'
                          options={profiles}
                          onChange={(value) => {
                            setFieldValue(
                              'dynamic_pricing.connector1_dynamic_pricing_id',
                              value,
                            );
                          }}
                          value={
                            values.dynamic_pricing.connector1_dynamic_pricing_id
                          }
                        />
                        <ErrorMessage
                          name='dynamic_pricing.connector1_dynamic_pricing_id'
                          component={S.MessageBox}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={24}>
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                      <Col lg={9}>
                        <S.ConnectorWrapper>Conector #2</S.ConnectorWrapper>
                      </Col>
                      <Col lg={15}>
                        <Select
                          placeholder='Escolha o perfil de precificação'
                          style={{ width: '100%', fontWeight: 300 }}
                          size='large'
                          options={profiles}
                          onChange={(value) => {
                            setFieldValue(
                              'dynamic_pricing.connector2_dynamic_pricing_id',
                              value,
                            );
                          }}
                          value={
                            values.dynamic_pricing.connector2_dynamic_pricing_id
                          }
                        />
                        <ErrorMessage
                          name='dynamic_pricing.connector2_dynamic_pricing_id'
                          component={S.MessageBox}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={24}>
                    <Row gutter={16}>
                      <Col lg={9}>
                        <S.ConnectorWrapper>Conector #3</S.ConnectorWrapper>
                      </Col>
                      <Col lg={15}>
                        <Select
                          placeholder='Escolha o perfil de precificação'
                          style={{ width: '100%', fontWeight: 300 }}
                          size='large'
                          options={profiles}
                          onChange={(value) => {
                            setFieldValue(
                              'dynamic_pricing.connector3_dynamic_pricing_id',
                              value,
                            );
                          }}
                          value={
                            values.dynamic_pricing.connector3_dynamic_pricing_id
                          }
                        />
                        <ErrorMessage
                          name='dynamic_pricing.connector3_dynamic_pricing_id'
                          component={S.MessageBox}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default DynamicPricingForm;
